import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import Select from "react-select";
import { RxCross2 } from "react-icons/rx";
import ChangeCommentList from "./commentList";
import AddCommentChange from "./addComment"
import { changeIssueOptions } from "helpers/changeOptions";
import { useUpdateChangeMutation } from "store/slices/apis/changeSlice";
import CustomTabs from "components/CustomTabs";
import DocumentManagement from "components/DocumentManagement";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);


const tabs = ["Change Information", "Documents"]

const EditChange = (props) => {
    const { open, handleClose, changeData, refetchCounts } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [updateChange] = useUpdateChangeMutation()
    const [tabValue, setTabValue] = useState(0);

    const module = "Change";

    const { data: changeCurrentStatusRes } = useGetMasterDataQuery({ module: module, category: 'CurrentStatus', ProjectId: projectId });
    const changeCurrentStatusData = changeCurrentStatusRes?.data || [];
    const statusOptions = (changeCurrentStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: changeFinalStatusRes } = useGetMasterDataQuery({ module: module, category: 'FinalStatus', ProjectId: projectId });
    const changeFinalStatusData = changeFinalStatusRes?.data || [];
    const changeFinalStatusOptions = mapAndSortAlphabetically(changeFinalStatusData);

    const { data: changeRaisedTypeRes } = useGetMasterDataQuery({ module: module, category: 'RaisedType', ProjectId: projectId });
    const changeRaisedTypeData = changeRaisedTypeRes?.data || [];
    const changeRaisedOptions = (changeRaisedTypeData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: changeChangeTypeRes } = useGetMasterDataQuery({ module: module, category: 'ChangeType', ProjectId: projectId });
    const changeChangeTypeData = changeChangeTypeRes?.data || [];
    const changeTypeOptions = mapAndSortAlphabetically(changeChangeTypeData);

    const { data: changeContractPackageRes } = useGetMasterDataQuery({ module: module, category: 'ContractPackage', ProjectId: projectId });
    const changeContractPackageData = changeContractPackageRes?.data || [];
    const contractPackageOptions = mapAndSortAlphabetically(changeContractPackageData);

    const [initialFormData, setInitialFormData] = useState({
        changeId: "",
        changeRequestNo: "",
        contract: "",
        requestorName: "",
        status: "",
        changeType: "",
        title: "",
        description: "",
        raisedDate: null,
        reasonJustification: "",
        reference: "",
        scopeImpact: "",
        timeImpact: "",
        costImpact: "",
        amountProposed: "",
        forwardedTo: "",
        changeAmount: "",
        recommendedChangeAmount: "",
        certifiedAmount: "",
        changeStatus: "",
        approvalDays: "",
        issue: "",
        daysChangeOrder: "",
        closureDate: null,
        approvalDate: null,
        issueDate: null,
        date: "",
        raisedType: "",
        projectId: projectId,
    });

    const formatDateForInput = (dateString) => {
        if (!dateString) return null;
        return moment(dateString).format('YYYY-MM-DD');
    };

    useEffect(() => {
        if (changeData && open) {
            const formattedData = {
                changeId: changeData.changeId || "",
                changeRequestNo: changeData.changeRequestNo || "",
                contract: changeData.contractPackage || "",
                requestorName: changeData.requestorName || "",
                status: changeData.currentStatus || "",
                changeType: changeData.changeType || "",
                title: changeData.changeTitle || "",
                description: changeData.description || "",
                raisedDate: formatDateForInput(changeData.dateRaised),
                reasonJustification: changeData.reasonJustification || "",
                reference: changeData.clauseContractReference || "",
                scopeImpact: changeData.scopeImpact || "",
                timeImpact: changeData.timeImpact || "",
                costImpact: changeData.costImpact || "",
                amountProposed: changeData.amountProposed || "",
                forwardedTo: changeData.forwardedTo || "",
                changeAmount: changeData.changeAmount || "",
                recommendedChangeAmount: changeData.recommendedChangeAmount || "",
                certifiedAmount: changeData.certifiedAmount || "",
                changeStatus: changeData.finalStatus || "",
                approvalDays: changeData.daysForInternalApproval || "",
                issue: changeData.isIssued || "",
                raisedType: changeData.raisedType || "",
                daysChangeOrder: changeData.daysForChangeOrderIssuance || "",
                closureDate: formatDateForInput(changeData.expectedClosureDate),
                approvalDate: formatDateForInput(changeData.approvalDate),
                issueDate: formatDateForInput(changeData.issueDate),
                projectId: projectId,
            };
            setInitialFormData(formattedData);
        }
    }, [changeData, open, projectId]);

    const validationSchema = Yup.object({
        changeRequestNo: Yup.string().required("Change Request No is required"),
        contract: Yup.string().required("Contract is required"),
        requestorName: Yup.string().required("Requestor Name is required"),
        status: Yup.string().required("Status is required"),
        changeType: Yup.string().required("Change Type is required"),
        title: Yup.string().required("Title is required"),
        description: Yup.string().required("Description is required"),
        raisedDate: Yup.date().required("Raised Date is required"),
        // reasonJustification: Yup.string().required("Reason/Justification is required"),
        // scopeImpact: Yup.string().required("Scope Impact is required"),
        // timeImpact: Yup.string().required("Time Impact is required"),
        // costImpact: Yup.string().required("Cost Impact is required"),
        amountProposed: Yup.number().required("Amount Proposed is required"),
        // forwardedTo: Yup.string().required("forwardAction is required"),
        // changeStatus: Yup.string().required("Change Status is required"),
        raisedType: Yup.string().required("Raised Type is Required"),
        issue: Yup.string().required("Issue is required"),
        reference: Yup.string().required("Reference is required"),
        changeAmount: Yup.number().typeError("Change Amount must be a number").positive("Change Amount must be positive").required("Change Amount is required"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        let reqBody = {
            changeId: changeData.changeId,
            projectCode: "string",
            changeRequestNo: values?.changeRequestNo,
            contractPackage: values?.contract,
            requestorName: values?.requestorName,
            currentStatus: values?.status,
            changeType: values?.changeType,
            changeTitle: values?.title,
            description: values?.description,
            dateRaised: values.raisedDate ? moment.utc(values?.raisedDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
            reasonJustification: values?.reasonJustification,
            clauseContractReference: values?.reference,
            scopeImpact: values?.scopeImpact,
            timeImpact: values?.timeImpact,
            costImpact: values?.costImpact,
            amountProposed: parseFloat(values?.amountProposed),
            forwardedTo: values?.forwardedTo,
            changeAmount: parseFloat(values?.changeAmount),
            recommendedChangeAmount: parseFloat(values?.recommendedChangeAmount),
            certifiedAmount: parseFloat(values?.certifiedAmount),
            finalStatus: values?.changeStatus,
            daysForInternalApproval: parseInt(values?.approvalDays),
            isIssued: Boolean(values?.issue),
            raisedType: values?.raisedType,
            daysForChangeOrderIssuance: parseInt(values?.daysChangeOrder),
            expectedClosureDate: values.closureDate ? moment.utc(values?.closureDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
            approvalDate: values.approvalDate ? moment.utc(values?.approvalDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
            issueDate: values.issueDate ? moment.utc(values?.issueDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
            "isActive": true,
        };



        try {
            const response = await updateChange({ body: reqBody }).unwrap();
            openNotification("Change request updated successfully", "success");
            setSubmitting(false);
            refetchCounts()
            handleClose();

        } catch (error) {
            openNotification(error?.error ?? "Something went wrong", "error");
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Dialog
            open={open}
            fullScreen
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: "27px",
                    lineHeight: "100%",
                    color: "#140F36",
                    fontFamily: "Outfit, sans-serif"
                }}>
                    Edit Change Request
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],

                    })}
                >
                    <RxCross2 size={30} color="#140F36" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    <CustomTabs tabValue={tabValue} handleTabChange={handleTabChange} tabs={tabs} />
                    {tabValue === 0 &&
                        <Grid container spacing={2}>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={initialFormData}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({ values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        setFieldValue,
                                        setFieldTouched }) => (
                                        <form onSubmit={handleSubmit}>
                                            <Grid container spacing={2}>
                                                <Grid size={12}>
                                                    <Typography sx={{ mt: 1, mb: 2, fontSize: "22px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                                                        Change Request Identificatiion
                                                    </Typography>
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Change Request Form No</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="changeRequestNo"
                                                        value={values.changeRequestNo}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Change Request No"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.changeRequestNo && errors.changeRequestNo && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.changeRequestNo}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Contract / Package</Typography>
                                                    <Select
                                                        name="contract"
                                                        options={contractPackageOptions}
                                                        value={contractPackageOptions.find(opt => opt.value === String(values.contract)) || null}
                                                        onChange={(option) => setFieldValue("contract", option.value)}
                                                        onBlur={() => setFieldTouched("contract", true)}
                                                        placeholder="Select Contract/Package"
                                                    />

                                                    {touched.contract && errors.contract && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.contract}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Requestor Name</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="requestorName"
                                                        value={values.requestorName}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Requestor Name"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.requestorName && errors.requestorName && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.requestorName}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Change Type
                                                    </Typography>
                                                    <Select
                                                        name="changeType"
                                                        options={changeTypeOptions}
                                                        value={changeTypeOptions.find(opt => opt.value === String(values.changeType)) || null}
                                                        onChange={(option) => setFieldValue("changeType", option.value)}
                                                        onBlur={() => setFieldTouched("changeType", true)}
                                                        placeholder="Select Change Type"
                                                    />
                                                    {touched.changeType && errors.changeType && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.changeType}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Raised Type
                                                    </Typography>
                                                    <Select
                                                        name="raisedType"
                                                        options={changeRaisedOptions}
                                                        value={changeRaisedOptions.find(opt => opt.value === String(values.raisedType)) || null}
                                                        onChange={(option) => setFieldValue("raisedType", option.value)}
                                                        onBlur={() => setFieldTouched("raisedType", true)}
                                                        placeholder="Select Raised Type"
                                                    />
                                                    {touched.raisedType && errors.raisedType && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.raisedType}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Date
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="date"
                                                        value={values.date}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input) input.showPicker?.();
                                                        }}
                                                        fullWidth
                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: "#fff",
                                                                border: '1px solid',
                                                                borderColor: 'hsl(0, 0%, 80%)',
                                                                height: "40px",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                    />
                                                    {touched.date && errors.date && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.date}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Raised Date
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="raisedDate"
                                                        value={values.raisedDate}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input) input.showPicker?.();
                                                        }}
                                                        fullWidth
                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: "#fff",
                                                                border: '1px solid',
                                                                borderColor: 'hsl(0, 0%, 80%)',
                                                                height: "40px",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                    />
                                                    {touched.raisedDate && errors.raisedDate && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.raisedDate}
                                                        </Typography>
                                                    )}
                                                </Grid>


                                                <Grid size={{ xs: 12 }}>
                                                    <Typography sx={{ mt: 2, mb: 1, fontSize: "20px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                                                        Estimated Impact
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Change Title / Brief</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="title"
                                                        value={values.title}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Title"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.title && errors.title && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.title}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Clause/Contract Reference</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="reference"
                                                        value={values.reference}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Reference"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.reference && errors.reference && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.reference}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Scope Impact
                                                    </Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="scopeImpact"
                                                        value={values.scopeImpact}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Scope Impact"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },

                                                            },
                                                        }}
                                                    />
                                                    {touched.scopeImpact && errors.scopeImpact && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.scopeImpact}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Time Impact
                                                    </Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="timeImpact"
                                                        value={values.timeImpactImpact}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Time Impact"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.timeImpact && errors.timeImpact && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.timeImpact}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Cost Impact
                                                    </Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="costImpact"
                                                        value={values.costImpact}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Scope Impact"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.costImpact && errors.costImpact && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.costImpact}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Amount Proposed</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="amountProposed"
                                                        value={values.amountProposed}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Amount Proposed"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.amountProposed && errors.amountProposed && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.amountProposed}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 12 }}>
                                                    <Typography sx={labelTextStyle}>Reason/Justification</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="reasonJustification"
                                                        value={values.reasonJustification}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        multiline
                                                        rows={2}
                                                        placeholder="Enter Reason/Justification"
                                                        InputProps={{
                                                            sx: {
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& textarea::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& textarea": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.reasonJustification && errors.reasonJustification && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.reasonJustification}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 12 }}>
                                                    <Typography sx={labelTextStyle}>Description</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="description"
                                                        value={values.description}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        multiline
                                                        rows={3}
                                                        placeholder="Enter Description"
                                                        InputProps={{
                                                            sx: {
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& textarea::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& textarea": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.description && errors.description && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.description}
                                                        </Typography>
                                                    )}
                                                </Grid>




                                                <Grid size={{ xs: 12 }}>
                                                    <Typography sx={{ mt: 2, mb: 1, fontSize: "20px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                                                        Internal Approval
                                                    </Typography>
                                                </Grid>


                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Estimated Change Amount</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="changeAmount"
                                                        value={values.changeAmount}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Change Amount"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.changeAmount && errors.changeAmount && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.changeAmount}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Current Status
                                                    </Typography>
                                                    <Select
                                                        name="status"
                                                        options={statusOptions}
                                                        value={statusOptions.find(opt => opt.value === String(values.status)) || null}
                                                        onChange={(option) => setFieldValue("status", option.value)}
                                                        onBlur={() => setFieldTouched("status", true)}
                                                        placeholder="Select Status"
                                                    />
                                                    {touched.status && errors.status && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.status}
                                                        </Typography>
                                                    )}
                                                </Grid>


                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Recommended Change Amount</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="recommendedChangeAmount"
                                                        value={values.recommendedChangeAmount}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Recommended Change Amount"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Certified Amount</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="certifiedAmount"
                                                        value={values.certifiedAmount}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Certified Amount"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Forwaded to (for action)
                                                    </Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="forwardedTo"
                                                        value={values.forwardedTo}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter forwarded to"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.forwardedTo && errors.forwardedTo && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.forwardedTo}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Final Status of Change
                                                    </Typography>
                                                    <Select
                                                        name="changeStatus"
                                                        options={changeFinalStatusOptions}
                                                        value={changeFinalStatusOptions.find(opt => opt.value === String(values.changeStatus)) || null}
                                                        onChange={(option) => setFieldValue("changeStatus", option.value)}
                                                        onBlur={() => setFieldTouched("changeStatus", true)}
                                                        placeholder="Select Change Status"
                                                    />
                                                    {touched.changeStatus && errors.changeStatus && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.changeStatus}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Expected date of closure
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="closureDate"
                                                        value={values.closureDate}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input) input.showPicker?.();
                                                        }}
                                                        fullWidth
                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: "#fff",
                                                                border: '1px solid',
                                                                borderColor: 'hsl(0, 0%, 80%)',
                                                                height: "40px",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Approval Date
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="approvalDate"
                                                        value={values.approvalDate}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input) input.showPicker?.();
                                                        }}
                                                        fullWidth
                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: "#fff",
                                                                border: '1px solid',
                                                                borderColor: 'hsl(0, 0%, 80%)',
                                                                height: "40px",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Days of Internal Approval</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="approvalDays"
                                                        value={values.approvalDays}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Approval Days"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid size={{ xs: 12 }}>
                                                    <Typography sx={{ mt: 2, mb: 1, fontSize: "20px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                                                        Change Order Issues
                                                    </Typography>
                                                </Grid>


                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Issue (Y/N)</Typography>
                                                    <Select
                                                        name="issue"
                                                        options={changeIssueOptions}
                                                        value={changeIssueOptions.find(opt => opt.value === String(values.issue)) || null}
                                                        onChange={(option) => setFieldValue("issue", option.value)}
                                                        onBlur={() => setFieldTouched("issue", true)}
                                                        placeholder="Select Issue"
                                                    />
                                                    {touched.issue && errors.issue && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.issue}
                                                        </Typography>
                                                    )}

                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Issue Date
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="issueDate"
                                                        value={values.issueDate}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input) input.showPicker?.();
                                                        }}
                                                        fullWidth
                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: "#fff",
                                                                border: '1px solid',
                                                                borderColor: 'hsl(0, 0%, 80%)',
                                                                height: "40px",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                {touched.issueDate && errors.issueDate && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.issueDate}
                                                    </Typography>
                                                )}
                                                <Grid size={{ xs: 12, md: 7 }}>
                                                    <Typography sx={labelTextStyle}>Days for Change Order Issuance ( CO date - Approval Date)</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="daysChangeOrder"
                                                        value={values.daysChangeOrder}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Days for Change Order"
                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.daysChangeOrder && errors.daysChangeOrder && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.daysChangeOrder}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={12}>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            alignItems: "center",
                                                            gap: 2,
                                                            mt: 3,
                                                        }}
                                                    >
                                                        <Button onClick={handleClose}
                                                            sx={{
                                                                textTransform: "none",
                                                                color: "#F15744",
                                                                fontSize: "14px",
                                                                lineHeight: "100%",
                                                                fontFamily: "Outfit, sans-serif",
                                                                borderRadius: "25px",
                                                                fontWeight: 500,
                                                                px: "20px",
                                                                py: "15px",
                                                            }}>
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            type="submit"
                                                            variant="contained"
                                                            disabled={isSubmitting}
                                                            sx={{
                                                                backgroundColor: "#00344C",
                                                                borderRadius: "25px",
                                                                textTransform: "none",
                                                                fontWeight: 500,
                                                                fontSize: "14px",
                                                                lineHeight: "100%",
                                                                fontFamily: "Outfit, sans-serif",
                                                                color: "#FFFFFF",
                                                                px: "20px",
                                                                py: "15px",
                                                                '&:disabled': {
                                                                    backgroundColor: '#cccccc',
                                                                }
                                                            }}
                                                        >
                                                            {isSubmitting ? "Updating..." : "Update"}
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    )}
                                </Formik>
                            </Grid>
                            <Grid
                                size={{ md: 6, xs: 12 }}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: '90vh', // adjustable
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 2,
                                    overflow: "auto",
                                }}
                            >
                                <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
                                    {/* Comment list */}
                                    <ChangeCommentList data={changeData} />
                                </Box>

                                <Box sx={{ borderTop: "1px solid #e0e0e0", p: 2 }}>
                                    <AddCommentChange data={changeData} />
                                </Box>
                            </Grid>
                        </Grid>
                    }
                    {tabValue === 1 &&
                        <Grid size={{ md: 12, xs: 12 }}>
                            <DocumentManagement id={changeData?.changeId} entityType="Change" customId={changeData?.customId} />
                        </Grid>
                    }
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default EditChange;